import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
const navLinks = [{
  href: '#inicio',
  label: 'Inicio'
}, {
  href: '#servicios',
  label: 'Servicios'
}, {
  href: '#catalogo',
  label: 'Catálogo'
}, {
  href: '#historia',
  label: 'Historia'
}, {
  href: '#ubicacion',
  label: 'Ubicación'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || menuOpen ? 'bg-[#121212]/90 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-126">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-127">
        <a href="#inicio" className="block relative z-50" onClick={() => setMenuOpen(false)} data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/3ADQKp1DHnDUdGH3xP27Pb/Onyx__Steel_Logo-Sin_fondo.png" alt="Onyx & Steel Logo" className="h-20 md:h-28 object-contain" data-id="element-129" />
        </a>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-10" data-id="element-130">
          <nav className="flex gap-8 text-xs tracking-[0.2em] uppercase font-medium text-white/80" data-id="element-131">
            {navLinks.map(link => <a key={link.href} href={link.href} className="hover:text-white hover:text-shadow-glow transition-all" data-id="element-132">
                {link.label}
              </a>)}
          </nav>
          <a href="#contact" data-id="element-133">
            <Button className="px-6 py-2.5 text-[10px] md:text-xs" data-id="element-134">
              Reserva Ahora
            </Button>
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button type="button" onClick={() => setMenuOpen(prev => !prev)} className="lg:hidden relative z-50 text-white p-2 -mr-2" aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} data-id="element-135">
          {menuOpen ? <XIcon className="w-7 h-7" data-id="element-136" /> : <MenuIcon className="w-7 h-7" data-id="element-137" />}
        </button>
      </div>

      {/* Mobile menu overlay - full screen liquid glass */}
      <AnimatePresence data-id="element-138">
        {menuOpen && <motion.div className="lg:hidden fixed inset-0 z-40 h-screen w-screen flex flex-col items-center justify-center gap-8 bg-[#121212]/80 backdrop-blur-2xl border-t border-white/10" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-139">
            <nav className="flex flex-col items-center gap-8 text-lg tracking-[0.25em] uppercase font-medium text-white/90" data-id="element-140">
              {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} onClick={() => setMenuOpen(false)} className="hover:text-gold transition-colors text-center" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 + index * 0.07
          }} data-id="element-141">
                  {link.label}
                </motion.a>)}
            </nav>
            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1 + navLinks.length * 0.07
        }} className="mt-4" data-id="element-142">
              <a href="#contact" onClick={() => setMenuOpen(false)} data-id="element-143">
                <Button data-id="element-144">Reserva Ahora</Button>
              </a>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}